/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ListingsInputs */

const en_listings = /** @type {(inputs: ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places`)
};

const de_listings = /** @type {(inputs: ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orte`)
};

/**
* | output |
* | --- |
* | "Places" |
*
* @param {ListingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const listings = /** @type {((inputs?: ListingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ListingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listings(inputs)
	return de_listings(inputs)
});